export default __webpack_public_path__ + "static/AppStoreLinks_Default-78a2ac10f65abc39a18958538917e3d2.png";